import { useMemo } from 'react';
import styles from './Sphere.module.css';

// Liste der verfügbaren Sphere-PNGs in `public/brand/spheres/`. Pool ist
// fix gepflegt — neue PNGs hier ergänzen. Suffixe sind die Tail-Teile
// nach `tro_sphere_` und vor `.png` (Naming-Inkonsistenzen im CI-Ordner
// werden absichtlich 1:1 übernommen — distortion / distortion1/2/3 / distorted).
const SPHERE_POOL = [
  'blue_1', 'blue_1_distortion', 'blue_2', 'blue_2_distortion', 'blue_3', 'blue_3_distortion',
  'blush_1', 'blush_1_distortion1', 'blush_2', 'blush_2_distortion2', 'blush_3', 'blush_3_distortion3',
  'eon_1', 'eon_1_distortion', 'eon_2', 'eon_2_distortion', 'eon_3', 'eon_3_distortion',
  'green_1', 'green_1_distortion', 'green_2', 'green_2_distortion', 'green_3', 'green_3_distortion2',
  'lavender_1', 'lavender_1_distortion3', 'lavender_2', 'lavender_2_distortion', 'lavender_3', 'lavender_3_distortion',
  'orange_1', 'orange_1_distortion', 'orange_2', 'orange_2_distortion', 'orange_3', 'orange_3_distortion3',
  'pink_1', 'pink_1_distortion', 'pink_2', 'pink_2_distortion', 'pink_3', 'pink_3_distortion1',
  'purple_1', 'purple_1_distortion', 'purple_2', 'purple_2_distortion', 'purple_3', 'purple_3_distortion',
  'red_1', 'red_1_distortion', 'red_2', 'red_2_distortion', 'red_3', 'red_3_distortion',
] as const;

type Variant = 'default' | 'corner';

export function Sphere({ variant = 'default' }: { variant?: Variant }) {
  const id = useMemo(
    () => SPHERE_POOL[Math.floor(Math.random() * SPHERE_POOL.length)]!,
    [],
  );
  return (
    <div
      className={`${styles.sphere} ${variant === 'corner' ? styles.corner : ''}`}
      style={{ backgroundImage: `url(/brand/spheres/tro_sphere_${id}.png)` }}
      aria-hidden="true"
    />
  );
}
